/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Popconfirm, InputNumber } from 'antd';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import PropTypes from 'prop-types';
import { getCoexecutorNIRDates, getCoexecutorSDates } from './utils';

const { TextArea } = Input;
const PlanRow = ({
    index,
    step,
    coexecutorData,
    formRef,
}) => {
    const [baseDocuments, setBaseDocuments] = useState([]);
    const [documents, setDocuments] = useState(
        coexecutorData?.[`etap${step}_documents`]
            ? JSON.parse(coexecutorData[`etap${step}_documents`])
            : [{}]
    );
    const [newDocumentName, setNewDocumentName] = useState('');

    useEffect(() => {
        setBaseDocuments([
            {
                label:
                    '– Отчет о выполнении научно-исследовательских работ или научно-исследовательских и опытно-конструкторских работ',
                deletable: false,
            },
            {
                label: '– Акт сдачи-приемки выполненных работ по этапу Договора',
                deletable: false,
            },
            {
                label: '– Финансовый отчет',
                deletable: false,
            },
        ]);
    }, []);

    const getResult = () => {
        switch (step) {
            case 1:
                return `${coexecutorData.coexecutorsPersonId.step1Result || ''} <br> ${coexecutorData.coexecutorsPersonId.step2Result || ''}`;
            case 2:
                return `${coexecutorData.coexecutorsPersonId.step3Result || ''} <br> ${coexecutorData.coexecutorsPersonId.step4Result || ''}`;
            case 3:
                return `${coexecutorData.coexecutorsPersonId.step5Result || ''} <br> ${coexecutorData.coexecutorsPersonId.step6Result || ''}`;
        }   
    }

    const handleAddDocument = () => {
        if (newDocumentName.length < 1) return;

        setDocuments([
            ...documents,
            {
                label: `– ${newDocumentName}\n`,
                deletable: true,
            },
        ]);
        setNewDocumentName('');
    };

    const handleDeleteDocument = (label) => {
        let documentsClone = structuredClone(documents);

        documentsClone = documentsClone.filter((el) => el.label !== label);

        setDocuments(documentsClone);
    };

    const handleEditDocument = (label) => {
        let documentsClone = structuredClone(documents);

        const documentToEdit = documentsClone.find((el) => el.label === label);

        documentToEdit.label = `– ${newDocumentName}\n`;

        setDocuments(documentsClone);
        setNewDocumentName('');
    };

    useEffect(() => {
        const fields = formRef.current.getFieldsValue();

        formRef.current.setFieldsValue({
            ...fields,
            [`etap${step}_documents`]: documents.filter(el => el.label).length > 0 ? JSON.stringify(documents.filter(el => el.label)) : JSON.stringify([{}]),
        });
    }, [documents]);

    return (
        <div className="common-table-row">
            <div
                className="common-table-row-cell"
                style={{ width: '4%', textAlign: 'center' }}
            >
                {index + 1}
            </div>
            <div
                className="common-table-row-cell"
                style={{ width: '24%', textAlign: 'center', fontWeight: 'bold' }}
            >{`Этап ${index + 1}`}</div>
            <Form.Item style={{ width: '24%' }}>
                <TextArea
                    value={coexecutorData.coexecutorsPersonId[`step${step}Work`]}
                    autoSize
                    disabled
                />
            </Form.Item>
            <div
                className="common-table-row-cell"
                style={{ width: '24%', textAlign: 'center' }}
            >
                {baseDocuments
                    .filter((el) => el.label)
                    .map((el) => (
                        <div>
                            <span>{el.label.replace('\n', '')}</span>
                            {el.deletable && (
                                <Popconfirm
                                    title="Удалить документ?"
                                    onConfirm={() => handleDeleteDocument(el.label)}
                                    okText="Да"
                                    cancelText="Нет"
                                >
                                    <Button style={{ marginLeft: 4 }} size="small" type="danger">
                                        Удалить
                                    </Button>
                                </Popconfirm>
                            )}
                        </div>
                    ))}
                {documents
                    .filter((el) => el.label)
                    .map((el) => (
                        <div>
                            <span>{el.label.replace('\n', '')}</span>
                            {el.deletable && (
                                <div>
                                    <Popconfirm
                                        title={
                                            <Input
                                                value={newDocumentName}
                                                onChange={(e) => setNewDocumentName(e.target.value)}
                                                label="Название документа"
                                                placeholder="Название документа"
                                            />
                                        }
                                        icon={<></>}
                                        okText="Сохранить"
                                        onOpenChange={() =>
                                            setNewDocumentName(
                                                el.label.replace('\n', '').replace('– ', '')
                                            )
                                        }
                                        onConfirm={() => handleEditDocument(el.label)}
                                    >
                                        <Button
                                            style={{ marginLeft: 4 }}
                                            size="small"
                                            type="primary"
                                        >
                                            Редактировать
                                        </Button>
                                    </Popconfirm>

                                    <Popconfirm
                                        title="Удалить документ?"
                                        onConfirm={() => handleDeleteDocument(el.label)}
                                        okText="Да"
                                        cancelText="Нет"
                                    >
                                        <Button
                                            style={{ marginLeft: 4 }}
                                            size="small"
                                            type="danger"
                                        >
                                            Удалить
                                        </Button>
                                    </Popconfirm>
                                </div>
                            )}
                        </div>
                    ))}
                <Popconfirm
                    title={
                        <Input
                            value={newDocumentName}
                            onChange={(e) => setNewDocumentName(e.target.value)}
                            label="Название документа"
                            placeholder="Название документа"
                        />
                    }
                    icon={<></>}
                    okText="Добавить"
                    onConfirm={handleAddDocument}
                >
                    <Button
                        style={{ marginTop: 10 }}
                        type="primary"
                        className="ant-btn ant-btn-primary"
                    >
                        Добавить документ
                    </Button>
                </Popconfirm>
                <Form.Item
                    style={{ width: '24%' }}
                    hidden
                    name={`etap${index + 1}_documents`}
                    initialValue={coexecutorData?.[`etap${index + 1}_documents`]}
                >
                    <Input />
                </Form.Item>
            </div>
            <div
                className="common-table-row-cell"
                style={{ width: '24%', textAlign: 'center' }}
            >
                {coexecutorData.isS ? getCoexecutorSDates(coexecutorData, step) : getCoexecutorNIRDates(coexecutorData, step)}
            </div>
            {coexecutorData.isNIR && (
                <Form.Item style={{ width: '24%', textAlign: 'center' }}>
                    <InputNumber
                        formatter={(value) =>
                            (parseInt(value, 10) || 0).toLocaleString('ru-RU')
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        disabled
                        value={coexecutorData.coexecutorsPersonId[`step${step}Sum`]}
                        style={{ width: '100%', textAlign: 'center' }}
                    />
                </Form.Item>
            )}
            {coexecutorData.isS && (
                <div
                    className="common-table-row-cell"
                    style={{ width: '24%', textAlign: 'center', padding: '10px 16px' }}
                    dangerouslySetInnerHTML={ {__html: getResult()}}
                >
                    
                </div>
            )}

        </div>
    );
};

PlanRow.propTypes = {
    index: PropTypes.number.isRequired,
    coexecutorData: PropTypes.shape().isRequired,
    formRef: PropTypes.shape().isRequired,
    step: PropTypes.number.isRequired,
};

export default PlanRow;
